import { CommonModule } from "@angular/common";
import { Component, DestroyRef, inject, OnDestroy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { TableModule } from "primeng/table";

import { BooksReviewService } from "../books-review.service";
import { WorkspacesService } from "../../workspaces.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { MomentModule } from "ngx-moment";
import { ToolData } from "../books-review.component";
import { EmptyStateComponent } from "src/app/design-system/components/empty-state/empty-state.component";

@Component({
  selector: "new-vendors",
  imports: [
    RouterModule,
    TableModule,
    CommonModule,
    FormsModule,
    BsDropdownModule,
    TooltipModule,
    TypeaheadModule,
    MomentModule,
    EmptyStateComponent,
  ],
  templateUrl: "./new-vendors.component.html",
  styleUrl: "../books-review.component.scss",
})
export class NewVendorsComponent implements OnDestroy {
  booksReviewService = inject(BooksReviewService);
  workspacesService = inject(WorkspacesService);
  localStorage = inject(LocalStorageService);

  company: any;

  data = [];
  loading: boolean = true;

  readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.localStorage.set("last_tab", "books-review/new-vendors");
    this.localStorage.set("last_tool", "new-vendors");
    this.booksReviewService.onToolChange$.next(null);

    this.workspacesService.$company
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((company) => {
        if (company == null) return;
        this.company = company;

        this.loadData();
      });

    this.booksReviewService.dateSelected$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((date) => {
        this.loadData();
      });
  }

  ngOnDestroy() {
    // No need to manually unsubscribe
  }

  loadData() {
    this.loading = true;
    this.booksReviewService
      .getToolData(this.company.uuid, "new-vendors")
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: ToolData) => {
        this.data = res.transactions;
        this.loading = false;
      });
  }
}
